<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-page-header
        style="border: 1px solid rgb(235, 237, 240);"
        title="银承/商承付款"
        @back="() => $router.back()">
      </a-page-header>
      <a-form layout="inline">
        <a-row :gutter="48" style="margin: 10px">
          <a-col :md="2" :sm="24" v-if="true">
            <a-button type="primary" @click="handleAdd">新建</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1200 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="face_value_render" slot-scope="text, record" style="text-align: right; min-width: 90px; max-width: 200px">
        {{ (text / 1).toFixed(4) | numberFormat }} （{{ $Dictionaries.currency[record.face_value_currency] || '' }}）
      </div>
      <div slot="margin_amount_render" slot-scope="text, record" style="text-align: right; min-width: 90px; max-width: 200px">
        {{ (text / 1).toFixed(4) | numberFormat }}（{{ $Dictionaries.currency[record.margin_amount_currency] || '' }}）
      </div>
      <div slot="margin_interest_rate_render" slot-scope="text" style="text-align: right; min-width: 90px; max-width: 200px">
        {{ (text / 1).toFixed(4) | numberFormat }} %
      </div>
      <div slot="open_discounting" slot-scope="text, record">
        <a-popover v-if="text">
          <template slot="content">
            <a-descriptions title="贴现" style="width: 900px">
              <a-descriptions-item label="贴现主体">
                {{ record.discounting_corporation }}
              </a-descriptions-item>
              <a-descriptions-item label="贴现银行">
                {{ record.discounting_bank }}
              </a-descriptions-item>
              <a-descriptions-item label="贴现日期">
                {{ record.discounting_date }}
              </a-descriptions-item>
              <a-descriptions-item label="贴现费用">
                {{ record.discounting_amount }}{{ $Dictionaries.currency[record.discounting_amount_currency] || '' }}
              </a-descriptions-item>
              <a-descriptions-item label="承担利息主体">
                {{ record.interest_payer }}
              </a-descriptions-item>
            </a-descriptions>
          </template>
          <a>
            {{ text ? '是' : '否' }}
          </a>
        </a-popover>
        <span v-else>
          {{ text ? '是' : '否' }}
        </span>
      </div>
      <div slot="open_maturity_pay" slot-scope="text, record">
        <a-popover v-if="text">
          <template slot="content">
            <a-descriptions title="到期付款" style="width: 600px">
              <a-descriptions-item label="到期付款日期">
                {{ record.maturity_pay_date }}
              </a-descriptions-item>
              <a-descriptions-item label="到期付款金额">
                {{ record.maturity_pay_amount }}
                {{ $Dictionaries.currency[record.maturity_pay_amount_currency] || '' }}
              </a-descriptions-item>
            </a-descriptions>
          </template>
          <a>
            {{ text ? '是' : '否' }}
          </a>
        </a-popover>
        <span v-else>
          {{ text ? '是' : '否' }}
        </span>
      </div>
      <span slot="approval_needed" slot-scope="text">
        <span class="desc">{{ text ? '是' : '否' }}</span>
      </span>
      <span slot="is_lc_acceptanced" slot-scope="text, item">
        <a-popconfirm
          title="确定承兑吗?"
          :disabled="text"
          @confirm="() => doAcceptance(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_lc_acceptanced" :disabled="item.is_lc_acceptanced"/>
        </a-popconfirm>
      </span>
      <span slot="is_audited" slot-scope="text, item">
        <a-popconfirm
          :title="auditTitle"
          @confirm="() => doAudit(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_audited"/>
        </a-popconfirm>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleAttachment(record)">附件</a>
          <a-divider type="vertical" v-if="!record.is_audited"/>
          <a @click="handleEdit(record)" v-if="!record.is_audited">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="record.is_lc_acceptanced && record.is_audited"/>
          <a @click="handleAcceptance(record)" v-if="record.is_lc_acceptanced && record.is_audited">承兑</a>
          <a-divider type="vertical" v-if="record.is_lc_acceptanced && record.is_audited"/>
          <a @click="handleLcCost(record)" v-if="record.is_lc_acceptanced && record.is_audited">成本</a>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import CreateForm from '../modules/CreateForm'
import {
  bank_commercial_acceptance_create, bank_commercial_acceptance_delete,
  bank_commercial_acceptance_list, bank_commercial_acceptance_update
} from '@/api/trade_bank_commercial_acceptance'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm
  },
  data () {
    return {
      approval_again: false,
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      archived_visible: false,
      mdl: {},
      projectList: [],
      clientList: [],
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '业务号',
          dataIndex: 'business_no',
          width: 150,
          ellipsis: true
        },
        {
          title: '票据种类',
          dataIndex: 'bill_type',
          align: 'center',
          width: 100,
          customRender: (text) => this.$Dictionaries.trade_bank_commercial_acceptance_type[text] || '无'
        },
        {
          title: '票据编码',
          dataIndex: 'bill_code',
          width: 180,
          ellipsis: true
        },
        {
          title: '承兑人',
          dataIndex: 'acceptor',
          width: 180,
          ellipsis: true
        },
        {
          title: '出票日期',
          dataIndex: 'issue_date',
          width: 180,
          ellipsis: true
        },
        {
          title: '票面金额',
          dataIndex: 'face_value',
          scopedSlots: { customRender: 'face_value_render' },
          align: 'right',
          width: 160,
          ellipsis: true
        },
        {
          title: '票据到期日',
          dataIndex: 'maturity_date',
          width: 140,
          align: 'right',
          ellipsis: true
        },
        {
          title: '贴现费率(%)',
          dataIndex: 'discount_rate',
          width: 140,
          align: 'right',
          ellipsis: true
        },
        {
          title: '是否到期可用',
          dataIndex: 'is_available_at_expiry',
          ellipsis: true,
          align: 'center',
          width: 120,
          customRender: (text) => text ? '是' : '否'
        },
        {
          title: '担保方式',
          dataIndex: 'guarantee_method',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '保证金金额',
          dataIndex: 'margin_amount',
          scopedSlots: { customRender: 'margin_amount_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '保证金起止日期',
          dataIndex: 'margin_start_date',
          width: 200,
          ellipsis: true,
          align: 'center',
          customRender: (text, record) => text + ' ~ ' + record.margin_end_date
        },
        {
          title: '保证金利率',
          dataIndex: 'margin_interest_rate',
          scopedSlots: { customRender: 'margin_interest_rate_render' },
          align: 'right',
          width: 120,
          ellipsis: true
        },
        {
          title: '贴现',
          dataIndex: 'is_open_discounting',
          scopedSlots: { customRender: 'open_discounting' },
          align: 'center',
          width: 160,
          ellipsis: true
        },
        {
          title: '到期付款',
          dataIndex: 'is_open_maturity_pay',
          scopedSlots: { customRender: 'open_maturity_pay' },
          align: 'center',
          width: 160,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '210px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData.parameter', parameter)
        return bank_commercial_acceptance_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log(res.data, '我是数据列表@')
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          getCheckboxProps: record => ({
            props: {
              disabled: record.is_archived
            }
          }),
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    this.queryParam.application_id = this.$route.query.lc_application_id
  },
  computed: {
    auditTitle () {
      return (item) => item ? '确定重新启动核验吗？' : '确定已经通过核验吗？'
    }
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            getCheckboxProps: record => ({
              props: {
                disabled: record.is_archived
              }
            }),
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      // const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      // const second = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
      this.mdl = { business_no: year + '' + month + '' + day + '' + hours }
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archived_visible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleArchivedCancel () {
      this.archived_visible = false
      const form = this.$refs.archivedModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleAttachment (record) {
      this.$router.push({ path: '/trade/bank_commercial_acceptance/' + record.id + '/attachment', query: { project: record.project, business_no: record.business_no } })
    },
    handleEdit (record) {
      this.$router.push({ path: '/trade/bank_commercial_acceptance/' + record.id, query: { lc_application_id: this.$route.query.lc_application_id } })
    },
    doAcceptance (record) {
      // 去承兑
      bank_commercial_acceptance_update({ is_lc_acceptanced: !record.is_lc_acceptanced }, record.id).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    doAudit (record) {
      // 去承兑
      bank_commercial_acceptance_update({ is_audited: !record.is_audited }, record.id).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleAcceptance (record) {
      this.$router.push({ path: '/trade/lc_issue/' + record.id + '/acceptance', query: { lc_application_id: this.$route.query.lc_application_id } })
    },
    handleLcCost (record) {
      console.log('chengben', record)
      this.lcCostVisible = true
      this.mdl = record
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      this.mdl = { business_no: year + '' + month + '' + day + '' + hours, ...record }
    },
    handleDelete (record) {
      bank_commercial_acceptance_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          // 新增
          values['date'] = undefined
          data['attachment'] = data['attachment'].map(item => {
            item['key'] = undefined
            return item
          })
          values = { ...values, ...data }
          console.log('values', values)
          values['application_id'] = this.$route.query.lc_application_id
          bank_commercial_acceptance_create(values).then(res => {
            if (res.code === 1000) {
              this.visible = false
              // 重置表单数据
              form.resetFields()
              // 刷新表格
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    }
  }
}
</script>
